<template>
  <div v-if="show" id="printContent">
    <div class="report-header">
      <div>{{ hotelName }}-{{ title }}</div>
      <div class="font-bold">{{ title }}</div>
      <div>
        <span>{{ $t('common.handledBy') }}：{{ name }}</span>
        <span v-if="!noBusiness">{{ $t('common.businessDay') }}：
          <template v-if="!startDate && printBusinessDay">{{ printBusinessDay }}</template>
          <template v-else-if="!startDate && !printBusinessDay">{{ businessDay }}</template>
          <template v-else>{{ startDate }} {{ $t('common.to') }} {{ endDate }}</template>
        </span>
        <span>{{ $t('common.printTime') }}：{{ formateTimesStamp(undefined, 'ymd hm') }}</span>
      </div>
    </div>
    <div class="report-content-wrapper">
      <slot></slot>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  name: 'ReportPrint',
  props: {
    title: {
      type: String,
      default: ''
    },
    startDate: {
      type: String,
      default: ''
    },
    endDate: {
      type: String,
      default: ''
    },
    printBusinessDay:{
      type: String,
      default: ''
    },
    noBusiness: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      show: false
    }
  },
  computed: {
    ...mapGetters(['name', 'hotelName', 'businessDay'])
  }
}
</script>
<style lang="scss" scoped>
  #printContent{
    position: absolute;
    top: 0;
    left: 0;
    z-index: -1;
    .report-header {
      font-size: 12px;
      color: #333333ff;
      padding: 5px;
      .font-bold {
        text-align: center;
        font-size: 20px;
        line-height: 1;
        padding-top: 10px;
        padding-bottom: 20px;
        font-weight: bold;
      }
      div:last-child {
        display: flex;
        span:first-child {
          padding-right: 40px;
        }
        span:last-child {
          flex: 1;
          text-align: right;
        }
      }
    }
    .report-content-wrapper{
      margin-top: 20px;
    }
  }
</style>
